module.exports = __webpack_public_path__ + "static/img/application4-6.8851c0c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/application/application4-6.jpg
// module id = JMyP
// module chunks = 0